import React from "react";
import { Stepper, Step, StepLabel, Box } from "@mui/material";

interface Steps {
	id: string;
	label: string;
}

interface FaiFormStepperProps {
	handleNewStep: (index: number, id: string) => void;
	activeStep: number;
	steps: Steps[];
}

const FaiFormStepper: React.FC<FaiFormStepperProps> = ({
	handleNewStep,
	activeStep,
	steps = [],
}) => {
	if (activeStep === null || activeStep < 0 || activeStep >= steps.length) {
		return null;
	}

	return (
		<Box className="text-center px-5 py-5 md:py-8 rounded-lg mx-auto md:mx-28 my-5 md:my-10 bg-[#4A4A4A]">
			<Box>
				<Stepper
					className="!m-0 !p-0"
					activeStep={activeStep}
					alternativeLabel
					sx={{
						"& .MuiStepConnector-line": {
							borderColor: "#bdbdbd",
							borderWidth: "0.1rem !important",
						},
					}}
				>
					{steps.map(({ label, id }, index) => (
						<Step
							className="cursor-pointer"
							key={index}
							onClick={() => handleNewStep(index, id)}
						>
							<StepLabel
								className="mt-1 md:mt-0"
								sx={{
									"& .Mui-active.MuiStepConnector-line": {
										borderColor: "#fff",
									},
									"& .MuiStepLabel-label.Mui-active": {
										fontWeight:
											activeStep === index ? "600 !important" : "normal",
									},
									"& .MuiStepLabel-label": {
										fontSize: "14px",
										fontWeight:
											activeStep === index ? "400 !important" : "normal",
										color: activeStep === index ? "#FFFFFF" : "#bdbdbd",
										"&.Mui-active": {
											color: "#FFFFFF !important",
										},
										"&.Mui-completed": {
											color: "#FFFFFF !important",
										},
									},
									"& .MuiStepIcon-root": {
										background:
											activeStep >= index ? "#FFFFFF !important" : "#4A4A4A",
										fill:
											activeStep >= index ? "#FFFFFF !important" : "#4A4A4A",
										stroke:
											activeStep >= index ? "#FFFFFF !important" : "#4A4A4A",
										fontSize: "1.5rem",
										border: activeStep < index ? "2px solid #FFFFFF" : "none",
									},
								}}
							>
								{label}
							</StepLabel>
						</Step>
					))}
				</Stepper>
			</Box>
		</Box>
	);
};

export default FaiFormStepper;
